/* ALOLA Videos — overlay vertical tipo stories. Sin dependencias. */
(function () {
  if (window.AlolaVideos) return;

  var ICON_CLOSE = '<svg viewBox="0 0 24 24"><path d="M19 6.4L17.6 5 12 10.6 6.4 5 5 6.4 10.6 12 5 17.6 6.4 19 12 13.4 17.6 19 19 17.6 13.4 12z"/></svg>';
  var ICON_MUTE = '<svg viewBox="0 0 24 24"><path d="M3 9v6h4l5 5V4L7 9H3zm13.5 3c0-1.8-1-3.3-2.5-4v8c1.5-.7 2.5-2.2 2.5-4zM14 3.2v2.1c2.9.9 5 3.5 5 6.7s-2.1 5.8-5 6.7v2.1c4-1 7-4.5 7-8.8s-3-7.8-7-8.8z"/><path d="M2.1 3.5L20.5 21.9l1.4-1.4L3.5 2.1z"/></svg>';
  var ICON_SOUND = '<svg viewBox="0 0 24 24"><path d="M3 9v6h4l5 5V4L7 9H3zm13.5 3c0-1.8-1-3.3-2.5-4v8c1.5-.7 2.5-2.2 2.5-4zM14 3.2v2.1c2.9.9 5 3.5 5 6.7s-2.1 5.8-5 6.7v2.1c4-1 7-4.5 7-8.8s-3-7.8-7-8.8z"/></svg>';
  var ICON_UP = '<svg viewBox="0 0 24 24"><path d="M12 8.4 4.6 15.8 6 17.2l6-6 6 6 1.4-1.4z"/></svg>';
  var ICON_DOWN = '<svg viewBox="0 0 24 24"><path d="M12 15.6 19.4 8.2 18 6.8l-6 6-6-6-1.4 1.4z"/></svg>';

  var SPEEDS = [1, 1.5, 2];

  var ov, track, btnPrev, btnNext, btnSpeed;
  var muted = true, speed = 1, sets = {}, current = -1, scrubbing = null;

  function data(setId) {
    if (sets[setId]) return sets[setId];
    var el = document.getElementById('alola-videos-data-' + setId);
    if (!el) return null;
    try { sets[setId] = JSON.parse(el.textContent); } catch (e) { sets[setId] = null; }
    return sets[setId];
  }

  function build() {
    if (ov) return;
    ov = document.createElement('div');
    ov.className = 'av-ov';
    ov.setAttribute('role', 'dialog');
    ov.setAttribute('aria-label', 'Videos');
    ov.innerHTML =
      '<div class="av-ov__track"></div>' +
      '<button class="av-ov__btn av-ov__speed" type="button" aria-label="Velocidad de reproduccion">1×</button>' +
      '<button class="av-ov__btn av-ov__sound" type="button" aria-label="Activar sonido">' + ICON_MUTE + '</button>' +
      '<button class="av-ov__btn av-ov__close" type="button" aria-label="Cerrar">' + ICON_CLOSE + '</button>' +
      '<div class="av-ov__nav">' +
        '<button type="button" class="av-ov__prev" aria-label="Video anterior">' + ICON_UP + '</button>' +
        '<button type="button" class="av-ov__next" aria-label="Siguiente video">' + ICON_DOWN + '</button>' +
      '</div>';
    document.body.appendChild(ov);
    track = ov.querySelector('.av-ov__track');
    btnPrev = ov.querySelector('.av-ov__prev');
    btnNext = ov.querySelector('.av-ov__next');
    btnSpeed = ov.querySelector('.av-ov__speed');
    ov.querySelector('.av-ov__close').addEventListener('click', close);
    ov.querySelector('.av-ov__sound').addEventListener('click', toggleSound);
    btnSpeed.addEventListener('click', cycleSpeed);
    btnPrev.addEventListener('click', function () { move(-1); });
    btnNext.addEventListener('click', function () { move(1); });
    document.addEventListener('keydown', function (e) {
      if (!ov.classList.contains('is-open')) return;
      if (e.key === 'Escape') close();
      if (e.key === 'ArrowDown') move(1);
      if (e.key === 'ArrowUp') move(-1);
    });
    track.addEventListener('scroll', onScroll, { passive: true });
    bindScrub();
  }

  function money(v) { return v == null ? '' : v; }

  function mmss(s) {
    if (!isFinite(s) || s < 0) s = 0;
    var m = Math.floor(s / 60), r = Math.floor(s % 60);
    return m + ':' + (r < 10 ? '0' : '') + r;
  }

  function slideHTML(v, i, total) {
    var prods = (v.p || []).map(function (p) {
      var price = '<span class="av-prod__price">' +
        (p.was ? '<span class="av-prod__was">' + money(p.was) + '</span>' : '') + money(p.now) + '</span>';
      var cta = p.vid
        ? '<form action="/cart/add" method="post" style="flex:0 0 auto;margin:0"><input type="hidden" name="id" value="' + p.vid + '"><input type="hidden" name="quantity" value="1"><button class="av-prod__cta" type="submit">Agregar</button></form>'
        : '<a class="av-prod__cta" href="' + p.u + '">Ver</a>';
      return '<div class="av-prod"><a href="' + p.u + '" style="display:flex;gap:10px;align-items:center;flex:1;min-width:0;text-decoration:none;color:inherit">' +
        (p.i ? '<img src="' + p.i + '" alt="" loading="lazy" width="56" height="56">' : '') +
        '<span class="av-prod__txt"><span class="av-prod__name">' + p.t + '</span>' + price + '</span></a>' + cta + '</div>';
    }).join('');
    var dots = (v.p && v.p.length > 1)
      ? '<div class="av-dots">' + v.p.map(function (_, j) { return '<span class="av-dot' + (j === 0 ? ' is-on' : '') + '"></span>'; }).join('') + '</div>'
      : '';
    var prog =
      '<div class="av-prog">' +
        '<div class="av-prog__track"><div class="av-prog__fill"></div><div class="av-prog__knob"></div></div>' +
        '<span class="av-prog__time">0:00 / 0:00</span>' +
      '</div>';
    return '<div class="av-slide" data-i="' + i + '">' +
      '<div class="av-slide__media">' +
      (v.c ? '<img class="av-poster" src="' + v.c + '" alt="" loading="lazy">' : '') +
      '<video playsinline muted loop preload="none" poster="' + (v.c || '') + '" data-src="' + v.s + '"></video>' +
      '<div class="av-slide__foot">' + prog +
      (prods ? '<div class="av-prods">' + prods + '</div>' + dots : '') +
      (v.x ? '<p class="av-cap">' + v.x + '</p>' : '') +
      '</div></div>' +
      (i === 0 && total > 1 ? '<span class="av-ov__hint">Desliza o usa las flechas</span>' : '') +
      '</div>';
  }

  function open(setId, index) {
    var list = data(setId);
    if (!list || !list.length) return;
    build();
    track.innerHTML = list.map(function (v, i) { return slideHTML(v, i, list.length); }).join('');
    ov.classList.add('is-open');
    document.documentElement.style.overflow = 'hidden';
    current = -1;
    var slides = track.querySelectorAll('.av-slide');
    if (slides[index]) track.scrollTop = slides[index].offsetTop;
    bindProds();
    setTimeout(function () { onScroll(); }, 30);
  }

  function close() {
    if (!ov) return;
    track.querySelectorAll('video').forEach(function (v) { v.pause(); v.removeAttribute('src'); v.load(); });
    ov.classList.remove('is-open');
    document.documentElement.style.overflow = '';
    track.innerHTML = '';
    current = -1;
  }

  function move(dir) {
    var slides = track.querySelectorAll('.av-slide');
    var next = Math.min(Math.max(current + dir, 0), slides.length - 1);
    if (slides[next]) track.scrollTo({ top: slides[next].offsetTop, behavior: 'smooth' });
  }

  function toggleSound() {
    muted = !muted;
    var btn = ov.querySelector('.av-ov__sound');
    btn.innerHTML = muted ? ICON_MUTE : ICON_SOUND;
    btn.setAttribute('aria-label', muted ? 'Activar sonido' : 'Silenciar');
    track.querySelectorAll('video').forEach(function (v) { v.muted = muted; });
  }

  function cycleSpeed() {
    var i = SPEEDS.indexOf(speed);
    speed = SPEEDS[(i + 1) % SPEEDS.length];
    btnSpeed.textContent = (speed === 1 ? '1' : String(speed)) + '×';
    track.querySelectorAll('video').forEach(function (v) { v.playbackRate = speed; });
  }

  function prime(slide) {
    var v = slide.querySelector('video');
    if (v && !v.src && v.dataset.src) { v.src = v.dataset.src; }
    return v;
  }

  function bindProgress(slide) {
    var v = slide.querySelector('video');
    var fill = slide.querySelector('.av-prog__fill');
    var knob = slide.querySelector('.av-prog__knob');
    var time = slide.querySelector('.av-prog__time');
    if (!v || !fill || v.dataset.avProg) return;
    v.dataset.avProg = '1';
    var paint = function () {
      var d = v.duration;
      if (!isFinite(d) || !d) return;
      var pct = Math.min(Math.max(v.currentTime / d, 0), 1) * 100;
      fill.style.width = pct + '%';
      if (knob) knob.style.left = pct + '%';
      if (time) time.textContent = mmss(v.currentTime) + ' / ' + mmss(d);
    };
    v.addEventListener('timeupdate', paint);
    v.addEventListener('loadedmetadata', paint);
    v.addEventListener('seeked', paint);
  }

  function seekAt(prog, clientX) {
    var slide = prog.closest('.av-slide');
    var v = slide && slide.querySelector('video');
    var bar = prog.querySelector('.av-prog__track');
    if (!v || !bar) return;
    if (!v.src && v.dataset.src) v.src = v.dataset.src;
    if (!isFinite(v.duration) || !v.duration) return;
    var r = bar.getBoundingClientRect();
    var ratio = Math.min(Math.max((clientX - r.left) / r.width, 0), 1);
    v.currentTime = ratio * v.duration;
  }

  function bindScrub() {
    track.addEventListener('pointerdown', function (e) {
      var prog = e.target.closest('.av-prog');
      if (!prog) return;
      scrubbing = prog;
      prog.classList.add('is-scrubbing');
      prog.setPointerCapture && prog.setPointerCapture(e.pointerId);
      seekAt(prog, e.clientX);
      e.preventDefault();
    });
    track.addEventListener('pointermove', function (e) {
      if (!scrubbing) return;
      seekAt(scrubbing, e.clientX);
      e.preventDefault();
    });
    var end = function () {
      if (!scrubbing) return;
      scrubbing.classList.remove('is-scrubbing');
      scrubbing = null;
    };
    track.addEventListener('pointerup', end);
    track.addEventListener('pointercancel', end);
  }

  function playSlide(slide) {
    var v = prime(slide);
    if (!v) return;
    v.muted = muted;
    v.playbackRate = speed;
    var intentos = 0;
    var go = function () {
      if (v.paused === false) return;
      var p = v.play();
      if (p && p.catch) {
        p.catch(function () {
          if (++intentos < 4) setTimeout(go, 250);
        });
      }
    };
    go();
    v.addEventListener('canplay', go, { once: true });
    v.addEventListener('loadeddata', go, { once: true });
  }

  var raf;
  function onScroll() {
    if (raf) return;
    raf = requestAnimationFrame(function () {
      raf = null;
      var slides = track.querySelectorAll('.av-slide');
      var i = Math.round(track.scrollTop / (track.clientHeight || 1));
      if (i === current) return;
      current = i;
      if (btnPrev) btnPrev.disabled = (i <= 0);
      if (btnNext) btnNext.disabled = (i >= slides.length - 1);
      slides.forEach(function (s, j) {
        var v = s.querySelector('video');
        if (!v) return;
        if (j === i) {
          playSlide(s);
          bindProgress(s);
          var poster = s.querySelector('.av-poster');
          if (poster) { if (!v.paused && v.currentTime > 0) { poster.style.opacity = '0'; } else { v.addEventListener('playing', function () { poster.style.opacity = '0'; }, { once: true }); } }
          var hint = s.querySelector('.av-ov__hint');
          if (hint) setTimeout(function () { hint.style.opacity = '0'; }, 2500);
        } else {
          v.pause();
          if (j === i + 1) { prime(s); bindProgress(s); }
        }
      });
    });
  }

  function bindProds() {
    track.querySelectorAll('.av-prods').forEach(function (row) {
      row.addEventListener('scroll', function () {
        var dots = row.parentNode.querySelectorAll('.av-dot');
        if (!dots.length) return;
        var k = Math.round(row.scrollLeft / (row.clientWidth || 1));
        dots.forEach(function (d, j) { d.classList.toggle('is-on', j === k); });
      }, { passive: true });
    });
  }

  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-alola-video]');
    if (!t) return;
    e.preventDefault();
    open(t.getAttribute('data-alola-video'), parseInt(t.getAttribute('data-index') || '0', 10));
  });

  /* ---- "Los de los productos de esta página": el navegador filtra los candidatos ---- */

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c];
    });
  }

  // handles de los productos que se ven: la grilla de la colección si existe, si no el contenido principal
  function pageHandles() {
    var root = document.getElementById('product-grid') || document.querySelector('main') || document.body;
    var have = {};
    root.querySelectorAll('product-card a[href*="/products/"]').forEach(function (a) {
      var m = (a.getAttribute('href') || '').match(/\/products\/([^\/?#]+)/);
      if (!m) return;
      try { have[decodeURIComponent(m[1])] = 1; } catch (e) { have[m[1]] = 1; }
    });
    return have;
  }

  function coverHTML(setId, v, i, radio) {
    var n = v.n || 0;
    return '<button class="av-cover" type="button" data-alola-video="' + setId + '" data-index="' + i + '" style="border-radius:' + radio + 'px" aria-label="' + esc(v.t) + '">' +
      '<img src="' + esc(v.c) + '" alt="' + esc(v.t) + '" loading="lazy" width="420" height="746">' +
      (n > 0 ? '<span class="av-cover__tag">' + n + ' producto' + (n > 1 ? 's' : '') + '</span>' : '') +
      '<span class="av-cover__play"><svg viewBox="0 0 24 24"><path d="M8 5v14l11-7z"/></svg></span></button>';
  }

  function refreshMarkers() {
    if (window.ScrollTrigger && window.ScrollTrigger.refresh) setTimeout(function () { window.ScrollTrigger.refresh(); }, 50);
  }

  function pagina(box) {
    var setId = box.getAttribute('data-av-pagina');
    var el = document.getElementById('alola-videos-cand-' + setId);
    var cand = [];
    try { cand = JSON.parse(el.textContent); } catch (e) {}
    var have = pageHandles();
    var max = parseInt(box.getAttribute('data-limite'), 10) || 20;
    var radio = box.getAttribute('data-radio') || '10';
    var list = cand.filter(function (v) {
      return (v.h || []).some(function (h) { return h && have[h]; });
    }).slice(0, max);
    var firma = list.map(function (v) { return v.s; }).join('|');
    if (box.getAttribute('data-av-firma') === firma && box.hasAttribute('data-av-listo')) return;
    box.setAttribute('data-av-firma', firma);
    box.setAttribute('data-av-listo', '');
    sets[setId] = list;
    box.innerHTML = list.map(function (v, i) { return coverHTML(setId, v, i, radio); }).join('');
    if (box.avFlechas) box.avFlechas();
    var wrap = box.closest('[data-av-section]');
    if (!wrap) return;
    if (list.length) {
      wrap.hidden = false;
      refreshMarkers();
    } else if (window.Shopify && window.Shopify.designMode) {
      wrap.hidden = false;
      box.innerHTML = '<p style="margin:0;padding:14px;border:1px dashed #c9c9c9;border-radius:8px;font-size:14px;opacity:.75">ALOLA Videos: ningún video tiene etiquetado un producto de esta página (en la tienda la sección no se muestra).</p>';
    } else {
      wrap.hidden = true;
    }
  }

  // página 2+ de una colección: Liquid no puede leer los videos ahí (paginate comparte ?page=),
  // así que se pide esta misma sección renderizada en la página 1 y se reemplaza el contenido
  function remoto(box) {
    var setId = box.getAttribute('data-av-remote');
    var wrap = box.closest('[data-av-section]');
    if (!wrap || !window.fetch) return;
    var q = new URLSearchParams(location.search);
    q.delete('page');
    q.set('section_id', setId);
    fetch(location.pathname + '?' + q.toString(), { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.text() : ''; })
      .then(function (html) {
        if (!html) return;
        var fresh = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-av-section]');
        if (!fresh) return;
        wrap.innerHTML = fresh.innerHTML;
        delete sets[setId];
        init(wrap);
        if (!wrap.querySelector('[data-av-pagina]')) { wrap.hidden = false; refreshMarkers(); }
      })
      .catch(function () {});
  }

  /* ---- Flechas ‹ › de la tira en escritorio: con un mouse de PC la rueda no la mueve (6-oct-2026) ---- */

  var ICON_IZQ = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M15 18l-6-6 6-6"/></svg>';
  var ICON_DER = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M9 18l6-6-6-6"/></svg>';

  // envuelve la tira en .av-marco con dos flechas; el CSS las muestra solo con mouse
  // y solo hacia el lado donde quedan videos escondidos
  function flechas(strip) {
    if (strip.avFlechas) { strip.avFlechas(); return; }
    var marco = document.createElement('div');
    marco.className = 'av-marco';
    strip.parentNode.insertBefore(marco, strip);
    marco.appendChild(strip);
    marco.insertAdjacentHTML('afterbegin', '<button type="button" class="av-flecha av-flecha--izq" tabindex="-1" aria-hidden="true">' + ICON_IZQ + '</button>');
    marco.insertAdjacentHTML('beforeend', '<button type="button" class="av-flecha av-flecha--der" tabindex="-1" aria-hidden="true">' + ICON_DER + '</button>');
    var act = function () {
      var max = strip.scrollWidth - strip.clientWidth;
      marco.classList.toggle('puede-izq', strip.scrollLeft > 2);
      marco.classList.toggle('puede-der', strip.scrollLeft < max - 2);
    };
    var mover = function (lado) {
      strip.scrollBy({ left: lado * Math.max(strip.clientWidth * 0.75, 160), behavior: 'smooth' });
    };
    marco.querySelector('.av-flecha--izq').addEventListener('click', function () { mover(-1); });
    marco.querySelector('.av-flecha--der').addEventListener('click', function () { mover(1); });
    strip.addEventListener('scroll', act, { passive: true });
    if (window.ResizeObserver) new ResizeObserver(act).observe(strip);
    else window.addEventListener('resize', act);
    window.addEventListener('load', act);
    strip.avFlechas = act;
    act();
  }

  function init(root) {
    root = root || document;
    root.querySelectorAll('[data-av-remote]').forEach(remoto);
    root.querySelectorAll('[data-av-pagina]').forEach(pagina);
    root.querySelectorAll('.av-strip').forEach(flechas);
  }

  // si la grilla cambia sin recargar (filtros, orden o paginación por AJAX), se vuelve a filtrar
  function watchGrid() {
    var grid = document.getElementById('product-grid');
    var root = grid && (grid.closest('main') || document.body);
    if (!root || !window.MutationObserver) return;
    var t;
    new MutationObserver(function () {
      clearTimeout(t);
      t = setTimeout(function () { document.querySelectorAll('[data-av-pagina]').forEach(pagina); }, 300);
    }).observe(root, { childList: true, subtree: true });
  }

  init(document);
  watchGrid();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });

  window.AlolaVideos = { open: open, close: close, refresh: function () { init(document); } };
})();